import { render } from "./ProposalManage.vue?vue&type=template&id=1de4d298"
import script from "./ProposalManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Billing/ProposalManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1de4d298"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1de4d298', __exports__)) {
    api.reload('1de4d298', __exports__)
  }
  
  module.hot.accept("./ProposalManage.vue?vue&type=template&id=1de4d298", () => {
    api.rerender('1de4d298', render)
  })

}


export default __exports__